import "@fontsource/roboto"
import "@fontsource/roboto/400.css"; // Regular
import "@fontsource/roboto/700.css"; // Bold

import "@fontsource/open-sans"
import "@fontsource/open-sans/400.css"; // Regular
import "@fontsource/open-sans/600.css"; // Semibold
import "@fontsource/open-sans/700.css"; // Bold

import "./src/styles/global.scss"

import React from "react"
import { ContentThemeProvider } from "./src/hooks/useContentTheme"

export const wrapRootElement = ({ element }) => (
  <ContentThemeProvider>{element}</ContentThemeProvider>
)
